// {{{ Switchboard.CallControl

GW.define('Switchboard.CallControl', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'office-call-control',
			children: [{
				className: 'main-box',
				children: [{
					className: 'left',
					children: [{
						ref: 'statusEl',
						className: 'status',
					},{
						ref: 'timerEl',
						className: 'timer',
					},{
						ref: 'peerEl',
						className: 'peer',
					},{
						ref: 'dialerInputEl',
						xtype: 'Office.DialerInput',
						'on:select': (c, contact) => {
							Office.CallManager.doAction({action: 'dial', number: c.sanitizeNumber(contact.number)});
						},
						'on:submit': (c, number) => {
							// clear the input
							c.setNumber('');
							Office.CallManager.doAction({action: 'dial', number});
						},
						'on:buttonclick': (c, btn) => {
							Office.CallManager.doAction({action: btn.id, number: c.getNumber()});
						}
					}]
				}, {
					className: 'controls',
					children: [{
						ref: 'statusIcon',
						className: 'status-icon',
					}, {
						ref: 'controlsEl',
						className: 'buttons',
					}],
					'on*:click': ev => {
						let el = ev.target.closest('button');
						if (el && !el.disabled) {
							this.fire('buttonclick', el.$data);
						}
					},
				}, {
					className: 'right',
					children: [{
						// show for no active attended transfer, keep in DOM to keep DOM state (focus, input value...)
						ref: 'transferInactiveEl',
						className: 'transfer-inactive-container hidden',
						xtype: 'Office.DialerInput',
						'after:initComponent'() {
							// there should be no buttons for transfer dialer input
							this.setButtons([]);
						},
						'on:select'(c, contact) {
							this.setNumber(contact.number);
						},
						placeholder: _('Přepojit na'),
					},{
						// show for active attended transfer:
						ref: 'transferActiveEl', // show either dialer input ('Office.DialerInput') or active transfer peer with dialer end button
						className: 'transfer-active-container hidden',
					}]
				}],
			}],
		}, this);
		Utils.interval(this, 'timer-update', 1000, () => this.renderCallTimer());
	},

	renderCallTimer() {
		let c = this.call;

		if (!c || (!c.start_ts && !c.early_ts)) {
			this.timerEl.textContent = '';
			return;
		}

		this.timerEl.textContent = c.start_ts ? Utils.getElapsedTime(c.start_ts) : Utils.getElapsedTime(c.early_ts);
	},

	setButtons(btns) {
		this.controlsEl.gwReplaceChildren(btns.map(b => {
			return {
				$data: b,
				nodeName: 'button',
				'attr:data-action': b.id,
				disabled: !!b.disabled,
				className: b.cls,
				children: [Utils.useIcon(b.icon)],
				title: b.title,
			};
		}));
	},

	setStatusIcon(icon, status) { // TODO deduplicate?
		if (icon) {
			this.statusIcon.gwReplaceChildren([Utils.useIcon(icon)]);
			this.statusIcon.classList.toggle('hidden', false);
			this.statusIcon.dataset = status;
		} else {
			this.statusIcon.classList.toggle('hidden', true);
			this.statusIcon.textContent = '';
			this.statusIcon.dataset = '';
		}
	},

	setCallData(call) {
		const call_buttons = () => [{
			id: 'hangup',
			icon: 'phone-end-filled',
			cls: 'error icon-only',
			disabled: !Office.CallManager.canDo('hangup'),
			title: call && call.status == 'incomming' ? _('Odmítnout') : _('Zavěsit'),
		}, 
		
		call && call.transfer ? {
			id: 'complete-transfer',
			icon: 'arrow-right',
			disabled: call.transfer.status !== 'connected',
			cls: 'success icon-only',
			title: _('Dokončit přepojení'),
		} : {
			id: 'blind-transfer',
			icon: 'arrow-right',
			disabled: !(call && call.status == 'connected'),
			cls: 'success-secondary icon-only',
			title: _('Přepojit'),
		}, 
			
		call && call.status === 'incomming' ? {
			id: 'answer',
			cls: 'success icon-only',
			icon: 'phone-filled',
			disabled: !Office.CallManager.canDo('answer'),
			title: _('Odpovědět'),
		} : {
			id: 'park',
			icon: 'park',
			disabled: !(call && call.status == 'connected' && !call.transfer),
			cls: 'secondary icon-only',
			title: _('Zaparkovat'),
		}, 
		
		{
			id: 'attended-transfer',
			icon: 'fi-corner-up-right',
			disabled: !(call && call.status == 'connected' && !call.transfer),
			cls: 'success-secondary icon-only btn-attended-transfer',
			title: _('Přepojit s odložením'),
		}];

		this.statusEl.classList.toggle('hidden', !call);
		this.peerEl.classList.toggle('hidden', !call);
		this.dialerInputEl.el.classList.toggle('hidden', !!call);

		this.setTransferData(call);

		this.call = call;

		this.renderCallTimer();

		this.el.dataset.status = call && call.status;
		
		if (!call) {
			// show all buttons, but disabled
			this.setButtons(call_buttons().map(btn => ({...btn, disabled: true})));
			
			this.setStatusIcon();
			this.timerEl.classList.toggle('hidden', true);
			return;
		}
		
		let statusTexts = {
			dialing: _('Vytáčím'),
			connected: _('Probíhající hovor'),
			incomming: _('Příchozí hovor'),
			hold: _('Odložený'),
			musichold: _('Odložený'),
		};

		let statusText = statusTexts[call.status] || call.status;
		if (call.transfer) {
			statusText = _('Přepojovaný');
		}

		if (call.chanspy_spied) {
			statusText = {
				connected: _('Probíhající odposlech'),
				incomming: _('Příchozí odposlech'),
			}[call.status] || statusText;
		}

		this.statusEl.textContent = statusText;
		if (call.status == 'dialing') {
			this.statusEl.gwCreateChild({
				nodeName: 'img',
				src: APP_BASE + 'img/dialing-animation.gif',
				className: 'icon',
			});
		}

		if (call.status == 'musichold' || call.transfer) {
			this.setStatusIcon('mute', 'muted');
		} else {
			this.setStatusIcon();
		}

		// XXX: changed from origina Office.CallControl code: queue before peer
		if (call.queue) {
			this.peerEl.gwCreateChild({
				className: 'queue',
				textContent: _('Fronta') + ' ' + call.queue + (call.queue_name ? ` - ${call.queue_name}` : ''),
			});
		}

		const peer = call.chanspy_spied || call.peer;
		if (peer) {
			this.peerEl.gwReplaceChildren([{
				className: 'number',
				textContent: peer.number,
			}]);

			const buildContactText = peer => [peer.name, peer.company].filter(v => v).join(', ').trim();

			const contactText = buildContactText(peer);
			const refs = {};
			this.peerEl.gwCreateChild({
				ref: 'contactTextEl',
				className: 'contact',
				textContent: contactText,
			}, refs);

			// disabled for switchboard
			// if (!contactText) {
			// 	// no text, either the contact does not exist or has empty data
			// 	this.renderButtonAddContact(refs.contactTextEl, peer.number, buildContactText);
			// }
		} else {
			this.peerEl.textContent = '';
		}

		this.peerEl.classList.toggle('hidden', !call.peer);
		this.timerEl.classList.toggle('hidden', !call.start_ts && !call.early_ts);

		this.setButtons(call_buttons());
	},


	setTransferData(call) {
		if (!call || call.status == 'disconnected') {
			this.transferInactiveEl.setNumber('');
		}

		let transfer = call && call.transfer;
		
		this.transferActiveEl.classList.toggle(
			'hidden', 
			!(call && call.transfer)
		);
		
		this.transferInactiveEl.setDisabled(!call);
		
		if (transfer) {
			const transfer_contact = transfer.contact || {};
			this.transferActiveEl.gwReplaceChildren([{
				children: [{
					// TODO: exten status icon
				}, {
					textContent: transfer_contact.number
				}]
			}, {
				className: 'peer',
				children: [{
					textContent: transfer_contact.name
				}, {
					':skip': transfer.status != 'dialing',
					nodeName: 'img',
					src: APP_BASE + 'img/dialing-animation.gif',
					className: 'icon',
				}]
			}, {
				classname: 'company',
				textContent: transfer_contact.company
			}, {
				nodeName: 'button',
				className: 'error icon-only btn-cancel-transfer',
				children: [Utils.useIcon('phone-end-filled')],
				title: _('Zrušit přepojení'),
				'on:click': () => {
					this.fire('buttonclick', {
						id: 'cancel-transfer',
					});
				}
			}]);
		} else {
			this.transferActiveEl.textContent = '';
		}
	},
	
	getTransferNumber() {
		return this.transferInactiveEl.getNumber();
	},
});

// }}}
// {{{ Switchboard.Dialer

GW.define('Switchboard.Dialer', 'GW.Component', {
	
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus switchboard-dialer panel-container',
			socketSubscriptions: ['parked_calls'],
			children: [{
				ref: 'queuedCallsList',
				className: 'calls-list top',
			}, {
				ref: 'activeCallEl', // active call(s)
				className: 'hidden',
				xtype: 'Switchboard.CallControl',
				'on:buttonclick': (c, btn) => {
					const action = btn.id;
					
					if (action == 'blind-transfer') {
						this.subscribed_linked_ids.add(Office.CallManager.getState().active_call.call_id);
						this.updateSubscribedLinkedIds();
						
						Office.CallManager.doAction({
							action: 'blind-transfer',
							number: c.getTransferNumber(),
							data: {
								timeout: env.SWITCHBOARD_FALLBACK_TIMEOUT,
								fallback: env.SWITCHBOARD_FALLBACK_QUEUE
							}, 
						});
						return;
					}
					
					if (action === 'park') {
						Office.CallManager.doAction({
							action: 'park',
							parkinglotType: 'switchboard',
						});
						return;
					}
					
					Office.CallManager.doAction({action, number: c.getTransferNumber()});
				}
			}, {
				ref: 'otherCalls', // held calls, blind transfer calls, parked calls
				className: 'calls-list bottom',
				children: [{
					ref: 'otherCallsPlaceholder',
					className: 'hidden empty',
					textContent: _('Žádné zaparkované hovory'),
				},{
					ref: 'subscribedCallsList' // blind transfer calls monitored via linked_ids
				}, {
					ref: 'parkedCallsList' // parked calls
				}]
			}]
		}, this);

		Utils.interval(this, 'timer-update', 1000, () => this.updateTimers());

		Application.socketSend({
			type: 'LOAD_PARKED_CALLS',
		});
		this.renderQueuedCalls(Office.QueueManager.queued_calls);
	},


	updateTimers() {
		for (let el of this.queuedCallsList.querySelectorAll('.timer')) {
			el.textContent = el.$start_ts ? Utils.getElapsedTime(el.$start_ts) : '';
		}
		for (let el of this.otherCalls.querySelectorAll('.timer')) {
			el.textContent = el.$start_ts ? Utils.getElapsedTime(el.$start_ts) : '';
		}
	},

	onBusMessage(msg) {
		if (msg.type == 'QUEUE_MANAGER_QUEUED_CALLS_CHANGE') {
			this.renderQueuedCalls(Office.QueueManager.queued_calls);
			
			this.renderSubscribedCalls(); // update subscribed calls - remove call if same is already in queued calls
		}

		if (msg.type == 'CALL_MANAGER_CHANGE') {
			this.renderDialerState();

			this.renderParkedCalls(); // update button state from an active call
			this.renderSubscribedCalls(); // update subscribed calls - remove call if same is already in queued calls
		}
		
		if (msg.type == 'SUBSCRIBED_CALLS_CHANGE') {
			this.updateSubscribedCalls({linked_ids: msg.linked_ids, reload: true});
		}

		if (msg.type === 'PARKED_CALLS_CHANGED') {
			this.renderParkedCalls(msg.data);
		}

		if (msg.type === 'CLIENT_SESSION_CHANGE' ||
			msg.type === 'CLIENT_WEBSOCKET_STATUS_CHANGE' && msg.ready) {
			
			Application.socketSend({
				type: 'LOAD_PARKED_CALLS',
			});
		}
	},


	renderQueuedCalls({calls, details}) {
		if (!calls.length) {
			this.queuedCallsList.gwReplaceChildren([{textContent: _('Žádné frontové hovory'), className: 'empty'}])
			return
		}
		this.queuedCallsList.gwReplaceChildren(calls.map(call => {
			const contact = details && details.contacts.find(c => c.phone == call.caller);
			const queue = details && details.queues.find(q => q.queue == call.queue);

			return {
				className: 'call-container',
				children: [{
					className: 'call-type-container',
					children: [{
						className: 'call-type-icon',
						children: [
							env.SWITCHBOARD_FALLBACK_QUEUE && call.queue == env.SWITCHBOARD_FALLBACK_QUEUE ?
								Utils.useIcon('fi-corner-up-left') :
								Utils.useIcon('phone-incoming')
						],
					}]
				}, {
					className: 'call',
					children: [{
						className: 'number',
						textContent: call.caller,
					}, {
						className: 'queue',
						textContent: call.queue ? (_('Fronta') + ' ' + call.queue + ((queue && queue.name) ? ` - ${queue.name}` : '')) : null,
					}, {
						className: 'contact',
						textContent: contact ? [contact.name, contact.company].filter(v => v).join(', ') : '',
					}, {
						className: 'timer',
						$start_ts: call.queue_join_ts,
					}],
				}]
			};
		}));
		this.updateTimers();
	},

	renderDialerState() {
		const {active_call} = Office.CallManager.getState();
		this.activeCallEl.setCallData(active_call);
		
	},

	// local state of subscribed calls <linked_id => {call, details}>:
	subscribed_calls: new Map(),
	subscribed_calls_timeout: null,
	subscribed_linked_ids: new Set(),

	updateSubscribedCalls({linked_ids}) {
		(linked_ids || this.subscribed_linked_ids).forEach(async (linked_id) => {
			const {call, details} = await REST.GET('active-call?linked_id=' + encodeURIComponent(linked_id));

			if (!call || call.start_ts) {
				// call ended or connected - remove the call and stop observing its linked_id
				this.subscribed_calls.delete(linked_id);
				this.subscribed_linked_ids.delete(linked_id);
				this.updateSubscribedLinkedIds();
			} else {
				this.subscribed_calls.set(linked_id, {call, details});
			}
			
			clearTimeout(this.subscribed_calls_timeout);
			this.subscribed_calls_timeout = setTimeout(() => this.renderSubscribedCalls(), 100);
		});
	},

	renderSubscribedCalls() {
		let update = false;
		for (let linked_id of this.subscribed_calls.keys()) {
			if (!Office.QueueManager.queued_calls.calls.map(call => call.linked_ids.includes(linked_id)) ||
				(Office.CallManager.getActiveCall() || {}).call_id == linked_id
			) {
				// make sure the calls are not amongst visible queued calls (including the active incoming one). 
				// This can happen if the call is returned back to the fallback queue. 
				// The call is shown in the queuedCalls (or in the dialer) and it should no longer be
				// visible in the subscribedCallsList, so remove it 
				this.subscribed_calls.delete(linked_id);
				this.subscribed_linked_ids.delete(linked_id);
				update = true;
			}
		}
		if (update) {
			this.updateSubscribedLinkedIds();
		}

		this.otherCallsPlaceholder.classList.toggle('hidden', this.parked_calls.calls.length > 0 || this.subscribed_calls.size > 0);

		const calls = [...this.subscribed_calls.values()];
		this.subscribedCallsList.gwReplaceChildren(calls.map(({call, details}) => {
			const contact = details && details.contacts.find(c => c.phone == call.caller);
			const peer_contact = details && call.callee.number && details.contacts.find(c => c.phone == call.callee.number);
			const queue = details && details.queues.find(q => q.queue == call.queue);

			return {
				className: 'call-container',
				children: [{
					className: 'call-type-container',
					children: [{
						className: 'call-type-icon',
						children: [Utils.useIcon('dialing')],
					}]
				}, {
					className: 'call',
					children: [{
						className: 'number',
						textContent: call.caller,
					}, {
						className: 'queue',
						textContent: call.queue ? (_('Fronta') + ' ' + call.queue + ((queue && queue.name) ? ` - ${queue.name}` : '')) : null,
					}, {
						className: 'contact',
						textContent: contact ? [contact.name, contact.company].filter(v => v).join(', ') : '',
					}],
				}, {
					className: 'call-peer',
					children: [
						Utils.useIcon('arrow-right')
					 , {
						className: 'number',
						textContent: call.callee.number,
					}, {
						className: 'contact',
						textContent: peer_contact ? [peer_contact.name, peer_contact.company].filter(v => v).join(', ') : '',
					}, {
						className: 'timer',
						$start_ts: call.dial_ts,
					}],
				}]
			};
		}));
		this.updateTimers();
	},


	updateSubscribedLinkedIds() {
		Application.socketSend({
			type: 'SUBSCRIBE_LINKED_IDS',
			linked_ids: [...this.subscribed_linked_ids]
		});
	},

	// local cached data for parked calls
	parked_calls: {
		calls: [],
		details: {},
	}, 

	renderParkedCalls(data) {
		if (data) {
			this.parked_calls = data;
		}

		this.otherCallsPlaceholder.classList.toggle('hidden', this.parked_calls.calls.length > 0 || this.subscribed_calls.size > 0);

		const {calls, details} = this.parked_calls;
		const {active_call} = Office.CallManager.getState();

		this.parkedCallsList.gwReplaceChildren(calls.map(call => {
			const contact = details && details.contacts.find(c => c.phone == call.caller);
			const queue = details && details.queues.find(q => q.queue == call.queue);

			return {
				className: 'call-container',
				children: [{
					className: 'call-type-container',
					children: [{
						className: 'call-type-icon',
						children: [Utils.useIcon('park')],
					}]
				}, {
					className: 'call',
					children: [{
						className: 'number',
						textContent: call.caller,
					}, {
						className: 'queue',
						textContent: call.queue ? (_('Fronta') + ' ' + call.queue + ((queue && queue.name) ? ` - ${queue.name}` : '')) : null,
					}, {
						className: 'contact',
						textContent: contact ? [contact.name, contact.company].filter(v => v).join(', ') : '',
					}, {
						className: 'parking-space',
						textContent: call.parking_space,
					}, {
						className: 'timer',
						$start_ts: call.parked_ts,
					}],
				}, {
					nodeName: 'button',
					className: 'secondary icon-only',
					disabled: active_call && active_call.status !== 'connected',
					children: [Utils.useIcon('arrow-up')],
					'on:click': async () => {
						await Office.CallManager.unpark(call);
					},
				}]
			};
		}));
		this.updateTimers();
	},
});


// {{{ Switchboard.MainPanel

GW.define('Switchboard.MainPanel', 'Office.OfficePanel', {
	title: _('Spojovatelka'),
	titleIcon: 'headphones',

	extendOfficePanel() {
		this.queueControl = new Office.QueueControlPanel({
			'after:initComponent'() {
				this.el.classList.add('page-centered-container');
				
				this.wrapEl.prepend(document.gwCreateElement({
					ref: 'callCountSumEl',
					className: 'queues-call-count-sum',
				}, this));
				
				this.wrapEl.append(document.gwCreateElement({
					nodeName: 'button',
					type: 'button',
					className: 'secondary icon-only large',
					children: [Utils.useIcon('visually-impaired')],
					'on:click': () => {
						let enabled = document.documentElement.classList.toggle('high-contrast-mode');
						if (enabled) {
							localStorage.setItem('ui-theme-high-contrast', true);
						} else {
							localStorage.removeItem('ui-theme-high-contrast', true);
						}
					}
				}, this));
				
				let highContrastThemeEnabled = localStorage.getItem('ui-theme-high-contrast');
				if (highContrastThemeEnabled) {
					document.documentElement.classList.add('high-contrast-mode');
				} else {
					document.documentElement.classList.remove('high-contrast-mode');
				}
				
				this.controlsEl.insertBefore(document.gwCreateElement({
					ref: 'allQueuesCheckBoxEl',
					className: 'switchboard-queues-joined',
					xtype: 'AckCheckboxField',
					cls: 'switch',
					shortText: _('V práci'),
					optional: true,
					'on:change': c => {
						if (c.getValue()) {
							Office.QueueManager.joinAllQueues(Application.session.user.extension);
						} else {
							Office.QueueManager.leaveAllQueues(Application.session.user.extension);
						}
					}
				}, this), this.subMenu);
			},
			
			'after:redrawQueues'() {
				if (this.callCountSumEl) {
					this.callCountSumEl.textContent = Office.QueueManager.queues
						.map(q => (q.info || {}).waiting_calls_count || 0)
						.reduce((a, b) => a + b, 0);
				}
				
				if (this.allQueuesCheckBoxEl) {
					this.allQueuesCheckBoxEl.setValue(
						Office.QueueManager.queues.every(q => q.state == 'subscribed' || q.state == 'paused')
					);
				}
			},
		});

		this.bodyEl.before(this.queueControl.el);
	},

	getDialerConfig() {
		return {
			xtype: 'Switchboard.Dialer',
		};
	},

	getControlPanelTabs() {
		// no control panel in switchboard
		return [];
	},

	'after:initComponent'() {
		Office.QueueManager.start();
		this.monDom(document, 'keydown', this.onDocKeyDown.bind(this));
	},

	'before:destroy'() {
		Office.QueueManager.end();
	},

	onDocKeyDown(ev) {
		const keyActions = {
			' ': () => {
				const active_call = Office.CallManager.getState().active_call;
				if (active_call) {
					if (active_call.status == 'incomming') {
						Office.CallManager.doAction({action: 'answer'});
					}
					if (active_call.status == 'connected') {
						Office.CallManager.doAction({action: 'park'});
					}
				}
			},
			'Ctrl_ ': () => {
				const parked_call = this.dialer.parked_calls.calls[0];
				if (parked_call) {
					Office.CallManager.unpark(parked_call);
				}
			},
			'Ctrl_F1': () => {
				if (document.activeElement) {
					document.activeElement.blur();
				}
				this.dialer.activeCallEl.dialerInputEl.input.focus();
			},
			'Ctrl_F2': () => {
				if (document.activeElement) {
					document.activeElement.blur();
				}
				this.dialer.activeCallEl.transferInactiveEl.input.focus();
			},
			'Ctrl_F9': () => {
				this.queueControl.allQueuesCheckBoxEl.toggle();
			},
			'F2': () => {
				const btn = this.dialer.activeCallEl.controlsEl.querySelector('.btn-attended-transfer');
				if (btn) {
					btn.click();
				}
			},
			'F8': () => {
				const active_call = Office.CallManager.getState().active_call;
				if (active_call) {
					Office.CallManager.doAction({action: 'hangup'});
				}
			},
			'F9': () => {
				const btn = this.dialer.activeCallEl.transferActiveEl.querySelector('.btn-cancel-transfer');
				if (btn) {
					btn.click();
				}
			},
		};

		const actionFunction = keyActions[Utils.describeKeyEvent(ev)];
		if (actionFunction) {
			ev.preventDefault();
			actionFunction();
		}
	},

});

// }}}


Application.addRoutes([{
	group: 'auth',
	module: 'switchboard',
	path: APP_BASE + 'switchboard',
	async handler({params}) {
		let c = Application.show({
			id: 'switchboard.main',
			xtype: 'Switchboard.MainPanel',
		});
		c.applyParams(params);
	}
}]);

Application.registerModule({
	id: 'switchboard',
	title: _('Spojovatelka'),
	tagline: _('Aplikace spojovatelka'),
	icon: 'headphones',
	href: APP_BASE + 'switchboard/',
});
